import ApiConnectionModule from "../../../component/form/api-connection-module/ApiConnectionModule";
import "./ApiConnections.scss";

interface ApiConnectionsUIProps {
  clientName: string;
  applicationId: string;
  weightronUid: string;
  weightronSecret: string;
  weightronApiKey: string;
  endpointUrl?: string;
  connectionInProgress: boolean;
  submissionInProgress: boolean;
  isSuccess: boolean;
  submitMsg?: string;
  collectionId: string;

  invalidClientName?: string;
  invalidApplicationId?: string;
  invalidWeightronUid?: string;
  invalidWeightronSecret?: string;
  invalidWeightronApiKey?: string;
  invalidEndpointUrl?: string;
  invalidCollectionId?: string;

  setClientName: (name: string) => void;
  setApplicationId: (id: string) => void;
  setWeightronUid: (uid: string) => void;
  setCollectionId: (id: string) => void;
  setWeightronSecret: (secret: string) => void;
  setWeightronApiKey: (key: string) => void;
  setEndpointUrl?: (url: string) => void;
  onEvaluateConnection: () => void;
  onSave: () => void;
  resetInvalidMsg: () => void;

  darkMode: boolean;
}

const ApiConnectionsUI = (props: ApiConnectionsUIProps) => {
  return (
    <div className={"connection-wrapper" + (props.darkMode ? " dark" : "")}>
      <ApiConnectionModule
        clientName={props.clientName}
        applicationId={props.applicationId}
        weightronUid={props.weightronUid}
        collectionId={props.collectionId}
        weightronSecret={props.weightronSecret}
        weightronApiKey={props.weightronApiKey}
        endpointUrl={props.endpointUrl}
        connectionInProgress={props.connectionInProgress}
        submissionInProgress={props.submissionInProgress}
        invalidClientName={props.invalidClientName}
        invalidApplicationId={props.invalidApplicationId}
        invalidWeightronUid={props.invalidWeightronUid}
        invalidWeightronSecret={props.invalidWeightronSecret}
        invalidWeightronApiKey={props.invalidWeightronApiKey}
        invalidCollectionId={props.invalidCollectionId}
        invalidEndpointUrl={props.invalidEndpointUrl}
        isSuccess={props.isSuccess}
        submitMsg={props.submitMsg}
        setClientName={props.setClientName}
        setApplicationId={props.setApplicationId}
        setWeightronUid={props.setWeightronUid}
        setCollectionId={props.setCollectionId}
        setWeightronSecret={props.setWeightronSecret}
        setWeightronApiKey={props.setWeightronApiKey}
        setEndpointUrl={props.setEndpointUrl}
        onEvaluateConnection={props.onEvaluateConnection}
        onSave={props.onSave}
        resetInvalidMsg={props.resetInvalidMsg}
        darkMode={props.darkMode}
      />
    </div>
  );
};

export default ApiConnectionsUI;
